import React from 'react';
import { Layout, Button, Space } from 'antd';
import './Header.css';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  return (
    <AntHeader className="app-header">
      <div className="logo">
        <img src="/logo.svg" alt="Brevis" width="120" onClick={() => window.open('https://brevis.network/')}/>
      </div>
      <div className="nav-links">
        <Space>
          <a href="https://pico-docs.brevis.network/" target="_blank" rel="noopener noreferrer">Pico zkVM</a>
          <a href="https://coprocessor-docs.brevis.network/" target="_blank" rel="noopener noreferrer">zkCoprocessor</a>
        </Space>
      </div>
      <div className="header-actions">
        <Button type="primary" className="contact-btn" onClick={() => window.open('https://form.typeform.com/to/lduiliob?typeform-source=brevis.network')}>Contact us</Button>
      </div>
    </AntHeader>
  );
};

export default Header;